import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

export const airbnb: GetCustomerCopyFunc = () => {
  return {
    countryISOCodesToHideWorkLifeServicesFor: new Set(['GB', 'IE']),
  }
}
